import React from 'react';
import { Box } from '@esgian/esgianui';
import { useTheme } from '@hooks';

// Create a wrapper component that allows us to style the outer scrollable container in react-window
// We must use forwardRef because react-window needs direct access to the scrolling element
const OuterBoxWithScrollbar = React.forwardRef((props, ref) => {
  const { customScrollbar } = useTheme();

  return (
    // This Box will be the actual scroll container used by FixedSizeList
    // ref is forwarded so react-window can call scrollTo etc. on it
    // props are spread in to apply required layout styles from react-window (like height, transform, etc.)
    <Box
      ref={ref} // Forward the ref to the DOM element (required!)
      {...props} // Spread react-window props like style, className, role, etc.
      sx={{
        overflowY: 'auto',
        ...customScrollbar
      }}
    />
  );
});

// Add a display name for better debugging and to shut ESLint up
OuterBoxWithScrollbar.displayName = 'OuterBoxWithScrollbar';

export default OuterBoxWithScrollbar;
